var map = {
	"./bbc54yyk/login_bg.jpg": 991,
	"./chaoxinxing/login_bg.jpg": 993,
	"./ecshopx/login_bg.jpg": 995,
	"./onex/login_bg.jpg": 1002,
	"./yyk/login_bg.jpg": 1004
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/login_bg\.jpg$
// module id = 114
// module chunks = 30